import {
  Component,
  OnInit,
  Input,
  ElementRef,
  Renderer2,
  Output,
  EventEmitter,
} from '@angular/core';

export interface CyborgSelectOption {
  assignName: string;
  id: string | number;
}

@Component({ standalone: false, 
  selector: 'cyborg-select',
  templateUrl: './cyborg-select.component.html',
  styleUrls: ['./cyborg-select.component.scss'],
})
export class CyborgSelectComponent implements OnInit {
  @Input() public selected: string | number;
  @Input() public options: CyborgSelectOption[];
  @Output() public selectChanged = new EventEmitter<string>();

  private selectElement: HTMLElement;

  constructor(private myElement: ElementRef, private renderer: Renderer2) {}

  public ngOnInit(): void {
    this.selectElement = this.myElement.nativeElement.querySelector(
      'select-input'
    ) as HTMLElement;
  }

  public onSelect(event: EventTarget): void {
    const target = event as HTMLElement;
    const id = target.getAttribute('data-value');
    this.selected = target.innerHTML;
    this.selectElement.parentElement.classList.remove('is-opened');

    target.parentElement.querySelectorAll('li').forEach((element) => {
      element.classList.remove('selected');
    });

    target.classList.toggle('selected');

    this.selectChanged.emit(id);
  }

  public onOpen(): void {
    this.selectElement.parentElement.classList.toggle('is-opened');
  }
}
